<template>
  <PreOrderDeliveryMemo
    :delivery="delivery"
    :deliveryMemo="deliveryMemo"
    :changeDelivery="changeDelivery"
  />
</template>

<script>
import PreOrderDeliveryMemo from '../../layouts/organisms/PreOrderDeliveryMemo/index'
import { notValidPattern } from '../../../../../models/PreOrder/OrderRequest'

export default {
  name: 'PreOrderDeliveryMemoContainer',
  components: { PreOrderDeliveryMemo },
  computed: {
    delivery() {
      return this.$store.getters['preOrder/delivery']
    },
    deliveryMemo() {
      return this.$store.getters['preOrder/delivery'].memo
    }
  },
  methods: {
    changeDelivery(delivery) {
      // TODO check src/presentationals/v1/components/order/DeliveryMemo.vue:41
      // const { memo: data } = delivery
      // const isWrapWord = /\n/.test(data)
      // let replaceMemo = data.replace(/\n/g, '')
      // if (isWrapWord && !this.isAndroid) {
      //   replaceMemo = replaceMemo.substr(0, replaceMemo.length - 1)
      // }
      // this.$store.commit('preOrder/setDelivery', { memo: replaceMemo })

      const { memo } = delivery

      if (memo !== undefined) {
        if (notValidPattern.test(memo)) {
          const replacedMemo = memo.replace(notValidPattern, '')

          this.$store.commit('preOrder/setDelivery', { memo: replacedMemo })

          this.$store.dispatch('toast/open', {
            text: '특수문자는 ;:,.?!-_()*%# 만 입력 가능합니다.'
          })

          return
        }
      }

      this.$store.commit('preOrder/setDelivery', delivery)
    }
  }
}
</script>
